import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
import { Link } from "react-router-dom";

import RegistrationTracking from "../components/RegistrationTracking";
import VersionHistory from "../components/VersionHistory";
import AdminGate from "../components/AdminGate";

export function JayContent() {
  return (
    <Box sx={{ maxWidth: 1400, mx: "auto", px: 3, py: 4 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Typography variant="h4" fontWeight="bold">
          Suivi des inscriptions
        </Typography>

        <Button
          component={Link}
          to="/jay/connexions"
          variant="outlined"
          startIcon={<TimelineIcon />}
        >
          Voir les connexions
        </Button>
      </Stack>

      <RegistrationTracking />

      <Divider sx={{ my: 4 }} />

      <VersionHistory />
    </Box>
  );
}

export default function JayAdmin() {
  return (
    <AdminGate role="admin">
      <JayContent />
    </AdminGate>
  );
}
